import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { SearchRoutingModule } from './search-routing.module';
import { SearchMobileComponent } from './view/search-mobile/search-mobile.component';
import { SearchComponent } from './components/search.component';
import { SearchDesktopComponent } from './view/desktop/search-desktop/search-desktop.component';
import { ListModule } from 'src/app/shared/components/list/list.module';
import { EquisLoadingModule } from '@tn-equis/core/components/loading';
import { EquisCardModule } from '@tn-equis/core/components/card';
import { EquisListModule } from '@tn-equis/core/components/list';
import { EquisStickerAnimationModule } from '@tn-equis/core/components/sticker-animation';

@NgModule({
  imports: [
    SearchRoutingModule,
    CommonModule,
    SearchRoutingModule,
    ListModule,
    EquisCardModule,
    EquisListModule,
    EquisStickerAnimationModule,
    EquisLoadingModule,
  ],
  declarations: [
    SearchComponent,
    SearchDesktopComponent,
    SearchMobileComponent,
  ],
})
export class SearchModule {}
